import { useQuery } from '@tanstack/react-query'

import i18n from './i18n'
import css from './index.module.css'

import { type AddToCartRentalParams, AddToCartRental } from '#/global/component/Product/AddToCart/Rental'
import { ProductPreviewCompact } from '#/global/component/Product/ProductPreviewCompact'

import { ServiceProduct } from '#/global/service/Product'

import { Config } from '#/global/helper/Config'
import { showProductDetail } from '#/global/helper/DataLayer/modalCrossSelling'

interface Props {
    date: {
        from: Date
        to: Date
    }
    hasUserAgreedWithGuarantee: boolean
    productCodeList: string[]
    typeOfRental: AddToCartRentalParams['typeOfRental']
}

export const ProductList = ({ productCodeList, ...addToCartProps }: Props) => {
    const productList = useQuery({
        queryKey: ['RentalRelatedItems', productCodeList],
        queryFn: async () => ServiceProduct.getProductRentalByCode(productCodeList, ['detail']),
    })

    const lang = Config.getLang()

    const t = i18n[lang]

    return (
        <div className={css.container}>
            <div>
                <h4>{t.title}</h4>
            </div>
            <div className={css.content}>
                {productList.isSuccess && productList.data !== undefined && productList.data.map(product => product && (
                    <ProductPreviewCompact
                        key={product.code}
                        lang={lang}
                        onTitleClick={() => showProductDetail(product.code)}
                        product={product}
                        AddToCart={(
                            <AddToCartRental
                                hasGuarantee={addToCartProps.hasUserAgreedWithGuarantee}
                                lang={lang}
                                product={product}
                                type="compact"
                                {...addToCartProps}
                            />
                        )}
                    />
                ))}
                {(!productList.isSuccess || productList.data === undefined) && Array.from({ length: productCodeList.length }).map((_, index) => (
                    <ProductPreviewCompact key={index} loadingState />
                ))}
            </div>
        </div>
    )
}
